import { render, staticRenderFns } from "./withdrawalRecord.vue?vue&type=template&id=50e85362&scoped=true&"
import script from "./withdrawalRecord.vue?vue&type=script&lang=js&"
export * from "./withdrawalRecord.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalRecord.vue?vue&type=style&index=0&id=50e85362&lang=scss&scoped=true&"
import style1 from "./withdrawalRecord.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e85362",
  null
  
)

export default component.exports